export const dishes = [
  {
    "categoryId": 1,
    "mealType": "STARTER",
    "type": "VEG",
    "description": "Paneer cubes in spicy onion gravy with onions and capsicum cubes.",
    "image": "https://www.cubesnjuliennes.com/wp-content/uploads/2020/03/Best-Kadai-Paneer-Recipe.jpg",
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "APPETIZER",
    "forChefit": true,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 1,
    "name": "Kadhai Paneer 1",
    "ingredients": [
      {
        "name": "Paneer",
        "quantity": "250g"
      },
      {
        "name": "Onions",
        "quantity": "2"
      },
      {
        "name": "Capsicum",
        "quantity": "2"
      },
      {
        "name": "Tomatoes",
        "quantity": "3"
      },
      {
        "name": "Spices",
        "quantity": "to taste"
      }
    ]
  },
  {
    "categoryId": 1,
    "mealType": "STARTER",
    "type": "NON-VEG",
    "description": "Paneer cubes in spicy onion gravy with onions and capsicum cubes.",
    "image": "https://www.indianhealthyrecipes.com/wp-content/uploads/2022/04/kadai-paneer-recipe.jpg",
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "APPETIZER",
    "forChefit": true,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 2,
    "name": "Kadhai Paneer 2",
    "ingredients": [
      {
        "name": "Paneer",
        "quantity": "250g"
      },
      {
        "name": "Onions",
        "quantity": "2"
      },
      {
        "name": "Capsicum",
        "quantity": "2"
      },
      {
        "name": "Tomatoes",
        "quantity": "3"
      },
      {
        "name": "Spices",
        "quantity": "to taste"
      }
    ]
  },
  {
    "categoryId": 1,
    "mealType": "STARTER",
    "type": "VEG",
    "description": "Paneer cubes in spicy onion gravy with onions and capsicum cubes.",
    "image": "https://cookoverheels.com/wp-content/uploads/2020/03/30-min-Dhaba-Style-Kadhai-Paneer.jpg",
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "APPETIZER",
    "forChefit": true,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 3,
    "name": "Kadhai Paneer 3",
    "ingredients": [
      {
        "name": "Paneer",
        "quantity": "250g"
      },
      {
        "name": "Onions",
        "quantity": "2"
      },
      {
        "name": "Capsicum",
        "quantity": "2"
      },
      {
        "name": "Tomatoes",
        "quantity": "3"
      },
      {
        "name": "Spices",
        "quantity": "to taste"
      }
    ]
  },
  {
    "categoryId": 1,
    "mealType": "STARTER",
    "type": "NON-VEG",
    "description": "Paneer cubes in spicy onion gravy with onions and capsicum cubes.",
    "image": "https://www.cookwithmanali.com/wp-content/uploads/2017/03/Best-Kadai-Paneer.jpg",
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "APPETIZER",
    "forChefit": true,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 4,
    "name": "Kadhai Paneer 4",
    "ingredients": [
      {
        "name": "Paneer",
        "quantity": "250g"
      },
      {
        "name": "Onions",
        "quantity": "2"
      },
      {
        "name": "Capsicum",
        "quantity": "2"
      },
      {
        "name": "Tomatoes",
        "quantity": "3"
      },
      {
        "name": "Spices",
        "quantity": "to taste"
      }
    ]
  },
  {
    "categoryId": 1,
    "mealType": "STARTER",
    "type": "VEG",
    "description": "Paneer cubes in spicy onion gravy with onions and capsicum cubes.",
    "image": "https://www.cubesnjuliennes.com/wp-content/uploads/2020/03/Best-Kadai-Paneer-Recipe.jpg",
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "APPETIZER",
    "forChefit": true,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 5,
    "name": "Kadhai Paneer 5",
    "ingredients": [
      {
        "name": "Paneer",
        "quantity": "250g"
      },
      {
        "name": "Onions",
        "quantity": "2"
      },
      {
        "name": "Capsicum",
        "quantity": "2"
      },
      {
        "name": "Tomatoes",
        "quantity": "3"
      },
      {
        "name": "Spices",
        "quantity": "to taste"
      }
    ]
  },
  {
    "categoryId": 1,
    "mealType": "STARTER",
    "type": "NON-VEG",
    "description": "Paneer cubes in spicy onion gravy with onions and capsicum cubes.",
    "image": "https://www.indianhealthyrecipes.com/wp-content/uploads/2022/04/kadai-paneer-recipe.jpg",
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "APPETIZER",
    "forChefit": true,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 6,
    "name": "Kadhai Paneer 6",
    "ingredients": [
      {
        "name": "Paneer",
        "quantity": "250g"
      },
      {
        "name": "Onions",
        "quantity": "2"
      },
      {
        "name": "Capsicum",
        "quantity": "2"
      },
      {
        "name": "Tomatoes",
        "quantity": "3"
      },
      {
        "name": "Spices",
        "quantity": "to taste"
      }
    ]
  },
  {
    "categoryId": 1,
    "mealType": "STARTER",
    "type": "VEG",
    "description": "Paneer cubes in spicy onion gravy with onions and capsicum cubes.",
    "image": "https://cookoverheels.com/wp-content/uploads/2020/03/30-min-Dhaba-Style-Kadhai-Paneer.jpg",
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "APPETIZER",
    "forChefit": true,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 7,
    "name": "Kadhai Paneer 7",
    "ingredients": [
      {
        "name": "Paneer",
        "quantity": "250g"
      },
      {
        "name": "Onions",
        "quantity": "2"
      },
      {
        "name": "Capsicum",
        "quantity": "2"
      },
      {
        "name": "Tomatoes",
        "quantity": "3"
      },
      {
        "name": "Spices",
        "quantity": "to taste"
      }
    ]
  },
  {
    "categoryId": 1,
    "mealType": "STARTER",
    "type": "NON-VEG",
    "description": "Paneer cubes in spicy onion gravy with onions and capsicum cubes.",
    "image": "https://www.cookwithmanali.com/wp-content/uploads/2017/03/Best-Kadai-Paneer.jpg",
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "APPETIZER",
    "forChefit": true,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 8,
    "name": "Kadhai Paneer 8",
    "ingredients": [
      {
        "name": "Paneer",
        "quantity": "250g"
      },
      {
        "name": "Onions",
        "quantity": "2"
      },
      {
        "name": "Capsicum",
        "quantity": "2"
      },
      {
        "name": "Tomatoes",
        "quantity": "3"
      },
      {
        "name": "Spices",
        "quantity": "to taste"
      }
    ]
  },
  {
    "categoryId": 1,
    "mealType": "MAIN COURSE",
    "type": "NON-VEG",
    "description": "Tandoori chicken is a popular Indian dish of chicken marinated in yogurt and spices.",
    "image": "/images/tandoori-chicken.png",
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "CURRY",
    "forChefit": true,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 9,
    "name": "Tandoori Chicken",
    "ingredients": [
      {
        "name": "Paneer",
        "quantity": "250g"
      },
      {
        "name": "Onions",
        "quantity": "2 Pc"
      },
      {
        "name": "Capsicum",
        "quantity": "2 Pc"
      },
      {
        "name": "Tomatoes",
        "quantity": "3 Pc"
      },
      {
        "name": "Spices",
        "quantity": "to taste"
      }
    ]
  },
  {
    "categoryId": 1,
    "mealType": "MAIN COURSE",
    "type": "VEG",
    "description": "Dal Makhani is a rich, slow-cooked Punjabi lentil dish made from whole black lentils (urad dal) and kidney beans simmered in a creamy, buttery, tomato-based sauce with spices.",
    "image": "/images/dak-makhni.png",
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "CURRY",
    "forChefit": true,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 10,
    "name": "Dak Makhni",
    "ingredients": [
      {
        "name": "Paneer",
        "quantity": "250g"
      },
      {
        "name": "Onions",
        "quantity": "2"
      },
      {
        "name": "Capsicum",
        "quantity": "2"
      },
      {
        "name": "Tomatoes",
        "quantity": "3"
      },
      {
        "name": "Spices",
        "quantity": "to taste"
      }
    ]
  },
  {
    "categoryId": 1,
    "mealType": "MAIN COURSE",
    "type": "VEG",
    "description": "Dal Makhani is a rich, slow-cooked Punjabi lentil dish made from whole black lentils (urad dal) and kidney beans simmered in a creamy, buttery, tomato-based sauce with spices.",
    "image": "/images/cabbage.png",
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "CURRY",
    "forChefit": true,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 11,
    "name": "Cabbage",
    "ingredients": [
      {
        "name": "Paneer",
        "quantity": "250g"
      },
      {
        "name": "Onions",
        "quantity": "2"
      },
      {
        "name": "Capsicum",
        "quantity": "2"
      },
      {
        "name": "Tomatoes",
        "quantity": "3"
      },
      {
        "name": "Spices",
        "quantity": "to taste"
      }
    ]
  },
  {
    "categoryId": 1,
    "mealType": "MAIN COURSE",
    "type": "NON-VEG",
    "description": "Paneer cubes in spicy onion gravy with onions and capsicum cubes.",
    "image": "https://www.cookwithmanali.com/wp-content/uploads/2017/03/Best-Kadai-Paneer.jpg",
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "CURRY",
    "forChefit": true,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 12,
    "name": "Kadhai Paneer 12",
    "ingredients": [
      {
        "name": "Paneer",
        "quantity": "250g"
      },
      {
        "name": "Onions",
        "quantity": "2"
      },
      {
        "name": "Capsicum",
        "quantity": "2"
      },
      {
        "name": "Tomatoes",
        "quantity": "3"
      },
      {
        "name": "Spices",
        "quantity": "to taste"
      }
    ]
  },
  {
    "categoryId": 1,
    "mealType": "MAIN COURSE",
    "type": "VEG",
    "description": "Paneer cubes in spicy onion gravy with onions and capsicum cubes.",
    "image": "https://www.cubesnjuliennes.com/wp-content/uploads/2020/03/Best-Kadai-Paneer-Recipe.jpg",
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "CURRY",
    "forChefit": true,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 13,
    "name": "Kadhai Paneer 13",
    "ingredients": [
      {
        "name": "Paneer",
        "quantity": "250g"
      },
      {
        "name": "Onions",
        "quantity": "2"
      },
      {
        "name": "Capsicum",
        "quantity": "2"
      },
      {
        "name": "Tomatoes",
        "quantity": "3"
      },
      {
        "name": "Spices",
        "quantity": "to taste"
      }
    ]
  },
  {
    "categoryId": 1,
    "mealType": "MAIN COURSE",
    "type": "NON-VEG",
    "description": "Paneer cubes in spicy onion gravy with onions and capsicum cubes.",
    "image": "https://www.indianhealthyrecipes.com/wp-content/uploads/2022/04/kadai-paneer-recipe.jpg",
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "CURRY",
    "forChefit": true,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 14,
    "name": "Kadhai Paneer 14",
    "ingredients": [
      {
        "name": "Paneer",
        "quantity": "250g"
      },
      {
        "name": "Onions",
        "quantity": "2"
      },
      {
        "name": "Capsicum",
        "quantity": "2"
      },
      {
        "name": "Tomatoes",
        "quantity": "3"
      },
      {
        "name": "Spices",
        "quantity": "to taste"
      }
    ]
  },
  {
    "categoryId": 1,
    "mealType": "MAIN COURSE",
    "type": "VEG",
    "description": "Paneer cubes in spicy onion gravy with onions and capsicum cubes.",
    "image": "https://cookoverheels.com/wp-content/uploads/2020/03/30-min-Dhaba-Style-Kadhai-Paneer.jpg",
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "CURRY",
    "forChefit": true,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 15,
    "name": "Kadhai Paneer 15",
    "ingredients": [
      {
        "name": "Paneer",
        "quantity": "250g"
      },
      {
        "name": "Onions",
        "quantity": "2"
      },
      {
        "name": "Capsicum",
        "quantity": "2"
      },
      {
        "name": "Tomatoes",
        "quantity": "3"
      },
      {
        "name": "Spices",
        "quantity": "to taste"
      }
    ]
  },
  {
    "categoryId": 1,
    "mealType": "MAIN COURSE",
    "type": "NON-VEG",
    "description": "Paneer cubes in spicy onion gravy with onions and capsicum cubes.",
    "image": "https://www.cookwithmanali.com/wp-content/uploads/2017/03/Best-Kadai-Paneer.jpg",
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "CURRY",
    "forChefit": true,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 16,
    "name": "Kadhai Paneer 16",
    "ingredients": [
      {
        "name": "Paneer",
        "quantity": "250g"
      },
      {
        "name": "Onions",
        "quantity": "2"
      },
      {
        "name": "Capsicum",
        "quantity": "2"
      },
      {
        "name": "Tomatoes",
        "quantity": "3"
      },
      {
        "name": "Spices",
        "quantity": "to taste"
      }
    ]
  },
  {
    "categoryId": 1,
    "mealType": "MAIN COURSE",
    "type": "VEG",
    "description": "Paneer cubes in spicy onion gravy with onions and capsicum cubes.",
    "image": "https://www.cubesnjuliennes.com/wp-content/uploads/2020/03/Best-Kadai-Paneer-Recipe.jpg",
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "CURRY",
    "forChefit": true,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 17,
    "name": "Kadhai Paneer 17",
    "ingredients": [
      {
        "name": "Paneer",
        "quantity": "250g"
      },
      {
        "name": "Onions",
        "quantity": "2"
      },
      {
        "name": "Capsicum",
        "quantity": "2"
      },
      {
        "name": "Tomatoes",
        "quantity": "3"
      },
      {
        "name": "Spices",
        "quantity": "to taste"
      }
    ]
  },
  {
    "categoryId": 1,
    "mealType": "MAIN COURSE",
    "type": "NON-VEG",
    "description": "Paneer cubes in spicy onion gravy with onions and capsicum cubes.",
    "image": "https://www.indianhealthyrecipes.com/wp-content/uploads/2022/04/kadai-paneer-recipe.jpg",
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "CURRY",
    "forChefit": true,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 18,
    "name": "Kadhai Paneer 18",
    "ingredients": [
      {
        "name": "Paneer",
        "quantity": "250g"
      },
      {
        "name": "Onions",
        "quantity": "2"
      },
      {
        "name": "Capsicum",
        "quantity": "2"
      },
      {
        "name": "Tomatoes",
        "quantity": "3"
      },
      {
        "name": "Spices",
        "quantity": "to taste"
      }
    ]
  },
  {
    "categoryId": 1,
    "mealType": "MAIN COURSE",
    "type": "VEG",
    "description": "Paneer cubes in spicy onion gravy with onions and capsicum cubes.",
    "image": "https://cookoverheels.com/wp-content/uploads/2020/03/30-min-Dhaba-Style-Kadhai-Paneer.jpg",
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "CURRY",
    "forChefit": true,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 19,
    "name": "Kadhai Paneer 19",
    "ingredients": [
      {
        "name": "Paneer",
        "quantity": "250g"
      },
      {
        "name": "Onions",
        "quantity": "2"
      },
      {
        "name": "Capsicum",
        "quantity": "2"
      },
      {
        "name": "Tomatoes",
        "quantity": "3"
      },
      {
        "name": "Spices",
        "quantity": "to taste"
      }
    ]
  },
  {
    "categoryId": 1,
    "mealType": "MAIN COURSE",
    "type": "NON-VEG",
    "description": "Paneer cubes in spicy onion gravy with onions and capsicum cubes.",
    "image": "https://www.cookwithmanali.com/wp-content/uploads/2017/03/Best-Kadai-Paneer.jpg",
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "CURRY",
    "forChefit": true,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 20,
    "name": "Kadhai Paneer 20",
    "ingredients": [
      {
        "name": "Paneer",
        "quantity": "250g"
      },
      {
        "name": "Onions",
        "quantity": "2"
      },
      {
        "name": "Capsicum",
        "quantity": "2"
      },
      {
        "name": "Tomatoes",
        "quantity": "3"
      },
      {
        "name": "Spices",
        "quantity": "to taste"
      }
    ]
  },
  {
    "categoryId": 1,
    "mealType": "DESSERT",
    "type": "VEG",
    "description": "Paneer cubes in spicy onion gravy with onions and capsicum cubes.",
    "image": "https://www.cubesnjuliennes.com/wp-content/uploads/2020/03/Best-Kadai-Paneer-Recipe.jpg",
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "SWEET",
    "forChefit": true,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 21,
    "name": "Kadhai Paneer 21",
    "ingredients": [
      {
        "name": "Paneer",
        "quantity": "250g"
      },
      {
        "name": "Onions",
        "quantity": "2"
      },
      {
        "name": "Capsicum",
        "quantity": "2"
      },
      {
        "name": "Tomatoes",
        "quantity": "3"
      },
      {
        "name": "Spices",
        "quantity": "to taste"
      }
    ]
  },
  {
    "categoryId": 1,
    "mealType": "DESSERT",
    "type": "NON-VEG",
    "description": "Paneer cubes in spicy onion gravy with onions and capsicum cubes.",
    "image": "https://www.indianhealthyrecipes.com/wp-content/uploads/2022/04/kadai-paneer-recipe.jpg",
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "SWEET",
    "forChefit": true,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 22,
    "name": "Kadhai Paneer 22",
    "ingredients": [
      {
        "name": "Paneer",
        "quantity": "250g"
      },
      {
        "name": "Onions",
        "quantity": "2"
      },
      {
        "name": "Capsicum",
        "quantity": "2"
      },
      {
        "name": "Tomatoes",
        "quantity": "3"
      },
      {
        "name": "Spices",
        "quantity": "to taste"
      }
    ]
  },
  {
    "categoryId": 1,
    "mealType": "DESSERT",
    "type": "VEG",
    "description": "Paneer cubes in spicy onion gravy with onions and capsicum cubes.",
    "image": "https://cookoverheels.com/wp-content/uploads/2020/03/30-min-Dhaba-Style-Kadhai-Paneer.jpg",
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "SWEET",
    "forChefit": true,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 23,
    "name": "Kadhai Paneer 23",
    "ingredients": [
      {
        "name": "Paneer",
        "quantity": "250g"
      },
      {
        "name": "Onions",
        "quantity": "2"
      },
      {
        "name": "Capsicum",
        "quantity": "2"
      },
      {
        "name": "Tomatoes",
        "quantity": "3"
      },
      {
        "name": "Spices",
        "quantity": "to taste"
      }
    ]
  },
  {
    "categoryId": 1,
    "mealType": "DESSERT",
    "type": "NON-VEG",
    "description": "Paneer cubes in spicy onion gravy with onions and capsicum cubes.",
    "image": "https://www.cookwithmanali.com/wp-content/uploads/2017/03/Best-Kadai-Paneer.jpg",
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "SWEET",
    "forChefit": true,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 24,
    "name": "Kadhai Paneer 24",
    "ingredients": [
      {
        "name": "Paneer",
        "quantity": "250g"
      },
      {
        "name": "Onions",
        "quantity": "2"
      },
      {
        "name": "Capsicum",
        "quantity": "2"
      },
      {
        "name": "Tomatoes",
        "quantity": "3"
      },
      {
        "name": "Spices",
        "quantity": "to taste"
      }
    ]
  },
  {
    "categoryId": 1,
    "mealType": "DESSERT",
    "type": "VEG",
    "description": "Paneer cubes in spicy onion gravy with onions and capsicum cubes.",
    "image": "https://www.cubesnjuliennes.com/wp-content/uploads/2020/03/Best-Kadai-Paneer-Recipe.jpg",
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "SWEET",
    "forChefit": true,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 25,
    "name": "Kadhai Paneer 25",
    "ingredients": [
      {
        "name": "Paneer",
        "quantity": "250g"
      },
      {
        "name": "Onions",
        "quantity": "2"
      },
      {
        "name": "Capsicum",
        "quantity": "2"
      },
      {
        "name": "Tomatoes",
        "quantity": "3"
      },
      {
        "name": "Spices",
        "quantity": "to taste"
      }
    ]
  },
  {
    "categoryId": 1,
    "mealType": "SIDES",
    "type": "NON-VEG",
    "description": "Paneer cubes in spicy onion gravy with onions and capsicum cubes.",
    "image": "https://www.indianhealthyrecipes.com/wp-content/uploads/2022/04/kadai-paneer-recipe.jpg",
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "SIDE",
    "forChefit": true,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 26,
    "name": "Kadhai Paneer 26",
    "ingredients": [
      {
        "name": "Paneer",
        "quantity": "250g"
      },
      {
        "name": "Onions",
        "quantity": "2"
      },
      {
        "name": "Capsicum",
        "quantity": "2"
      },
      {
        "name": "Tomatoes",
        "quantity": "3"
      },
      {
        "name": "Spices",
        "quantity": "to taste"
      }
    ]
  },
  {
    "categoryId": 1,
    "mealType": "SIDES",
    "type": "VEG",
    "description": "Paneer cubes in spicy onion gravy with onions and capsicum cubes.",
    "image": "https://cookoverheels.com/wp-content/uploads/2020/03/30-min-Dhaba-Style-Kadhai-Paneer.jpg",
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "SIDE",
    "forChefit": true,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 27,
    "name": "Kadhai Paneer 27",
    "ingredients": [
      {
        "name": "Paneer",
        "quantity": "250g"
      },
      {
        "name": "Onions",
        "quantity": "2"
      },
      {
        "name": "Capsicum",
        "quantity": "2"
      },
      {
        "name": "Tomatoes",
        "quantity": "3"
      },
      {
        "name": "Spices",
        "quantity": "to taste"
      }
    ]
  },
  {
    "categoryId": 1,
    "mealType": "SIDES",
    "type": "NON-VEG",
    "description": "Paneer cubes in spicy onion gravy with onions and capsicum cubes.",
    "image": "https://www.cookwithmanali.com/wp-content/uploads/2017/03/Best-Kadai-Paneer.jpg",
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "SIDE",
    "forChefit": true,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 28,
    "name": "Kadhai Paneer 28",
    "ingredients": [
      {
        "name": "Paneer",
        "quantity": "250g"
      },
      {
        "name": "Onions",
        "quantity": "2"
      },
      {
        "name": "Capsicum",
        "quantity": "2"
      },
      {
        "name": "Tomatoes",
        "quantity": "3"
      },
      {
        "name": "Spices",
        "quantity": "to taste"
      }
    ]
  },
  {
    "categoryId": 1,
    "mealType": "SIDES",
    "type": "VEG",
    "description": "Paneer cubes in spicy onion gravy with onions and capsicum cubes.",
    "image": "https://www.cubesnjuliennes.com/wp-content/uploads/2020/03/Best-Kadai-Paneer-Recipe.jpg",
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "SIDE",
    "forChefit": true,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 29,
    "name": "Kadhai Paneer 29",
    "ingredients": [
      {
        "name": "Paneer",
        "quantity": "250g"
      },
      {
        "name": "Onions",
        "quantity": "2"
      },
      {
        "name": "Capsicum",
        "quantity": "2"
      },
      {
        "name": "Tomatoes",
        "quantity": "3"
      },
      {
        "name": "Spices",
        "quantity": "to taste"
      }
    ]
  },
  {
    "categoryId": 1,
    "mealType": "SIDES",
    "type": "NON-VEG",
    "description": "Paneer cubes in spicy onion gravy with onions and capsicum cubes.",
    "image": "https://www.indianhealthyrecipes.com/wp-content/uploads/2022/04/kadai-paneer-recipe.jpg",
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "SIDE",
    "forChefit": true,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 30,
    "name": "Kadhai Paneer 30",
    "ingredients": [
      {
        "name": "Paneer",
        "quantity": "250g"
      },
      {
        "name": "Onions",
        "quantity": "2"
      },
      {
        "name": "Capsicum",
        "quantity": "2"
      },
      {
        "name": "Tomatoes",
        "quantity": "3"
      },
      {
        "name": "Spices",
        "quantity": "to taste"
      }
    ]
  }
]

/* 
1. given mock data structure
[
  {
    "categoryId": 1,
    "mealType": "MAIN COURSE",
    "type": "VEG",
    "description": "Paneer cubes in spicy onion gravy with onions and capsicum cubes.",
    "image": null,
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "CURRY",
    "forChefit": true,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 1,
    "name": "Kadhai Paneer 1"
  },
  {
    "categoryId": 1,
    "mealType": "MAIN COURSE",
    "type": "VEG",
    "description": "Paneer cubes in spicy onion gravy with onions and capsicum cubes.",
    "image": null,
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "CURRY",
    "forChefit": true,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 2,
    "name": "Kadhai Paneer 2"
  },
  {
    "categoryId": 1,
    "mealType": "MAIN COURSE",
    "type": "VEG",
    "description": "Paneer cubes in spicy onion gravy with onions and capsicum cubes.",
    "image": null,
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "CURRY",
    "forChefit": true,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 3,
    "name": "Kadhai Paneer 3"
  },
  {
    "categoryId": 1,
    "mealType": "MAIN COURSE",
    "type": "VEG",
    "description": "Paneer cubes in spicy onion gravy with onions and capsicum cubes.",
    "image": null,
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "CURRY",
    "forChefit": true,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 4,
    "name": "Kadhai Paneer 4"
  },
  {
    "categoryId": 1,
    "mealType": "MAIN COURSE",
    "type": "VEG",
    "description": "Paneer cubes in spicy onion gravy with onions and capsicum cubes.",
    "image": null,
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "CURRY",
    "forChefit": true,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 5,
    "name": "Kadhai Paneer 5"
  },
  {
    "categoryId": 1,
    "mealType": "MAIN COURSE",
    "type": "VEG",
    "description": "Paneer cubes in spicy onion gravy with onions and capsicum cubes.",
    "image": null,
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "CURRY",
    "forChefit": true,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 6,
    "name": "Kadhai Paneer 6"
  },
  {
    "categoryId": 1,
    "mealType": "MAIN COURSE",
    "type": "VEG",
    "description": "Paneer cubes in spicy onion gravy with onions and capsicum cubes.",
    "image": null,
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "CURRY",
    "forChefit": true,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 7,
    "name": "Kadhai Paneer 7"
  },
  {
    "categoryId": 1,
    "mealType": "MAIN COURSE",
    "type": "VEG",
    "description": "Paneer cubes in spicy onion gravy with onions and capsicum cubes.",
    "image": null,
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "CURRY",
    "forChefit": true,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 8,
    "name": "Kadhai Paneer 8"
  },
  {
    "categoryId": 1,
    "mealType": "MAIN COURSE",
    "type": "VEG",
    "description": "Paneer cubes in spicy onion gravy with onions and capsicum cubes.",
    "image": null,
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "CURRY",
    "forChefit": true,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 9,
    "name": "Kadhai Paneer 9"
  },
  {
    "categoryId": 1,
    "mealType": "MAIN COURSE",
    "type": "VEG",
    "description": "Paneer cubes in spicy onion gravy with onions and capsicum cubes.",
    "image": null,
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "CURRY",
    "forChefit": true,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 10,
    "name": "Kadhai Paneer 10"
  },
  {
    "categoryId": 1,
    "mealType": "MAIN COURSE",
    "type": "VEG",
    "description": "Paneer cubes in spicy onion gravy with onions and capsicum cubes.",
    "image": null,
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "CURRY",
    "forChefit": true,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 11,
    "name": "Kadhai Paneer 11"
  },
  {
    "categoryId": 1,
    "mealType": "MAIN COURSE",
    "type": "VEG",
    "description": "Paneer cubes in spicy onion gravy with onions and capsicum cubes.",
    "image": null,
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "CURRY",
    "forChefit": true,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 12,
    "name": "Kadhai Paneer 12"
  },
  {
    "categoryId": 1,
    "mealType": "MAIN COURSE",
    "type": "VEG",
    "description": "Paneer cubes in spicy onion gravy with onions and capsicum cubes.",
    "image": null,
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "CURRY",
    "forChefit": true,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 13,
    "name": "Kadhai Paneer 13"
  },
  {
    "categoryId": 1,
    "mealType": "MAIN COURSE",
    "type": "VEG",
    "description": "Paneer cubes in spicy onion gravy with onions and capsicum cubes.",
    "image": null,
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "CURRY",
    "forChefit": true,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 14,
    "name": "Kadhai Paneer 14"
  },
  {
    "categoryId": 1,
    "mealType": "MAIN COURSE",
    "type": "VEG",
    "description": "Paneer cubes in spicy onion gravy with onions and capsicum cubes.",
    "image": null,
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "CURRY",
    "forChefit": true,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 15,
    "name": "Kadhai Paneer 15"
  },
  {
    "categoryId": 1,
    "mealType": "MAIN COURSE",
    "type": "VEG",
    "description": "Paneer cubes in spicy onion gravy with onions and capsicum cubes.",
    "image": null,
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "CURRY",
    "forChefit": true,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 16,
    "name": "Kadhai Paneer 16"
  },
  {
    "categoryId": 1,
    "mealType": "MAIN COURSE",
    "type": "VEG",
    "description": "Paneer cubes in spicy onion gravy with onions and capsicum cubes.",
    "image": null,
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "CURRY",
    "forChefit": true,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 17,
    "name": "Kadhai Paneer 17"
  },
  {
    "categoryId": 1,
    "mealType": "MAIN COURSE",
    "type": "VEG",
    "description": "Paneer cubes in spicy onion gravy with onions and capsicum cubes.",
    "image": null,
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "CURRY",
    "forChefit": true,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 18,
    "name": "Kadhai Paneer 18"
  },
  {
    "categoryId": 1,
    "mealType": "MAIN COURSE",
    "type": "VEG",
    "description": "Paneer cubes in spicy onion gravy with onions and capsicum cubes.",
    "image": null,
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "CURRY",
    "forChefit": true,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 19,
    "name": "Kadhai Paneer 19"
  },
  {
    "categoryId": 1,
    "mealType": "MAIN COURSE",
    "type": "VEG",
    "description": "Paneer cubes in spicy onion gravy with onions and capsicum cubes.",
    "image": null,
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "CURRY",
    "forChefit": true,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 20,
    "name": "Kadhai Paneer 20"
  },
  {
    "categoryId": 1,
    "mealType": "MAIN COURSE",
    "type": "VEG",
    "description": "Paneer cubes in spicy onion gravy with onions and capsicum cubes.",
    "image": null,
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "CURRY",
    "forChefit": true,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 21,
    "name": "Kadhai Paneer 21"
  },
  {
    "categoryId": 1,
    "mealType": "MAIN COURSE",
    "type": "VEG",
    "description": "Paneer cubes in spicy onion gravy with onions and capsicum cubes.",
    "image": null,
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "CURRY",
    "forChefit": true,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 22,
    "name": "Kadhai Paneer 22"
  },
  {
    "categoryId": 1,
    "mealType": "MAIN COURSE",
    "type": "VEG",
    "description": "Paneer cubes in spicy onion gravy with onions and capsicum cubes.",
    "image": null,
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "CURRY",
    "forChefit": true,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 23,
    "name": "Kadhai Paneer 23"
  },
  {
    "categoryId": 1,
    "mealType": "MAIN COURSE",
    "type": "VEG",
    "description": "Paneer cubes in spicy onion gravy with onions and capsicum cubes.",
    "image": null,
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "CURRY",
    "forChefit": true,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 24,
    "name": "Kadhai Paneer 24"
  },
  {
    "categoryId": 1,
    "mealType": "MAIN COURSE",
    "type": "VEG",
    "description": "Paneer cubes in spicy onion gravy with onions and capsicum cubes.",
    "image": null,
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "CURRY",
    "forChefit": true,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 25,
    "name": "Kadhai Paneer 25"
  },
  {
    "categoryId": 1,
    "mealType": "MAIN COURSE",
    "type": "VEG",
    "description": "Paneer cubes in spicy onion gravy with onions and capsicum cubes.",
    "image": null,
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "CURRY",
    "forChefit": true,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 26,
    "name": "Kadhai Paneer 26"
  },
  {
    "categoryId": 1,
    "mealType": "MAIN COURSE",
    "type": "VEG",
    "description": "Paneer cubes in spicy onion gravy with onions and capsicum cubes.",
    "image": null,
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "CURRY",
    "forChefit": true,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 27,
    "name": "Kadhai Paneer 27"
  },
  {
    "categoryId": 1,
    "mealType": "MAIN COURSE",
    "type": "VEG",
    "description": "Paneer cubes in spicy onion gravy with onions and capsicum cubes.",
    "image": null,
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "CURRY",
    "forChefit": true,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 28,
    "name": "Kadhai Paneer 28"
  },
  {
    "categoryId": 1,
    "mealType": "MAIN COURSE",
    "type": "VEG",
    "description": "Paneer cubes in spicy onion gravy with onions and capsicum cubes.",
    "image": null,
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "CURRY",
    "forChefit": true,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 29,
    "name": "Kadhai Paneer 29"
  },
  {
    "categoryId": 1,
    "mealType": "MAIN COURSE",
    "type": "VEG",
    "description": "Paneer cubes in spicy onion gravy with onions and capsicum cubes.",
    "image": null,
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "CURRY",
    "forChefit": true,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 30,
    "name": "Kadhai Paneer 30"
  }
]
*/

/*
2. extra mock data with different images
[
  {
    "categoryId": 1,
    "mealType": "MAIN COURSE",
    "type": "VEG",
    "description": "Paneer cubes in spicy onion gravy with onions and capsicum cubes.",
    "image": "/images/kadhai-paneer-indian-curry.jpg",
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "MAIN_COURSE",
    "forChefit": true,
    "forParty": true,
    "nameHi": "कड़ाही पनीर",
    "nameBn": "",
    "id": 1,
    "name": "Kadhai Paneer",
    "ingredients": [
      {
        "name": "Paneer",
        "quantity": "200g"
      },
      {
        "name": "Onion",
        "quantity": "2 large"
      },
      {
        "name": "Capsicum",
        "quantity": "1 large"
      },
      {
        "name": "Tomato Puree",
        "quantity": "1 cup"
      }
    ]
  },
  {
    "categoryId": 1,
    "mealType": "MAIN COURSE",
    "type": "NON-VEG",
    "description": "Tandoori chicken is a dish made from chicken marinated in yogurt and spices.",
    "image": "/images/tandoori-chicken-indian-grilled.jpg",
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "MAIN_COURSE",
    "forChefit": true,
    "forParty": true,
    "nameHi": "तंदूरी चिकन",
    "nameBn": "",
    "id": 2,
    "name": "Tandoori Chicken",
    "ingredients": [
      {
        "name": "Chicken",
        "quantity": "500g"
      },
      {
        "name": "Yogurt",
        "quantity": "1 cup"
      },
      {
        "name": "Tandoori Masala",
        "quantity": "2 tbsp"
      },
      {
        "name": "Ginger Garlic Paste",
        "quantity": "1 tbsp"
      }
    ]
  },
  {
    "categoryId": 1,
    "mealType": "MAIN COURSE",
    "type": "VEG",
    "description": "Dal makhani is an Indian dish originating from the Punjab region.",
    "image": "/images/dal-makhani-indian-lentils.jpg",
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "MAIN_COURSE",
    "forChefit": true,
    "forParty": true,
    "nameHi": "दाल मखनी",
    "nameBn": "",
    "id": 3,
    "name": "Dal Makhani",
    "ingredients": [
      {
        "name": "Black Lentils",
        "quantity": "1 cup"
      },
      {
        "name": "Kidney Beans",
        "quantity": "1/4 cup"
      },
      {
        "name": "Butter",
        "quantity": "2 tbsp"
      },
      {
        "name": "Cream",
        "quantity": "1/4 cup"
      }
    ]
  },
  {
    "categoryId": 2,
    "mealType": "MAIN COURSE",
    "type": "VEG",
    "description": "Crispy South Indian crepe made from fermented rice and lentil batter.",
    "image": "/images/dosa-south-indian-crepe.png",
    "category": {
      "id": 2,
      "name": "South Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/south_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "MAIN_COURSE",
    "forChefit": true,
    "forParty": false,
    "nameHi": "डोसा",
    "nameBn": "দোসা",
    "id": 4,
    "name": "Dosa",
    "ingredients": [
      {
        "name": "Rice",
        "quantity": "2 cups"
      },
      {
        "name": "Urad Dal",
        "quantity": "1/2 cup"
      },
      {
        "name": "Fenugreek Seeds",
        "quantity": "1/2 tsp"
      },
      {
        "name": "Salt",
        "quantity": "to taste"
      }
    ]
  },
  {
    "categoryId": 1,
    "mealType": "STARTER",
    "type": "VEG",
    "description": "Crispy fried pastry with spiced potato filling.",
    "image": "/images/samosa-indian-snack-fried.jpg",
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "APPETIZER",
    "forChefit": true,
    "forParty": true,
    "nameHi": "समोसा",
    "nameBn": "সমুচা",
    "id": 5,
    "name": "Samosa",
    "ingredients": [
      {
        "name": "All Purpose Flour",
        "quantity": "2 cups"
      },
      {
        "name": "Potatoes",
        "quantity": "4 medium"
      },
      {
        "name": "Green Peas",
        "quantity": "1/2 cup"
      },
      {
        "name": "Oil",
        "quantity": "for frying"
      }
    ]
  },
  {
    "categoryId": 1,
    "mealType": "STARTER",
    "type": "NON-VEG",
    "description": "Grilled chunks of seasoned boneless chicken.",
    "image": "/images/chicken-tikka-grilled-indian.jpg",
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "APPETIZER",
    "forChefit": true,
    "forParty": true,
    "nameHi": "चिकन टिक्का",
    "nameBn": "",
    "id": 6,
    "name": "Chicken Tikka",
    "ingredients": [
      {
        "name": "Chicken Breast",
        "quantity": "500g"
      },
      {
        "name": "Yogurt",
        "quantity": "1/2 cup"
      },
      {
        "name": "Red Chili Powder",
        "quantity": "1 tsp"
      },
      {
        "name": "Garam Masala",
        "quantity": "1 tsp"
      }
    ]
  },
  {
    "categoryId": 6,
    "mealType": "DESSERT",
    "type": "VEG",
    "description": "Sweet deep-fried dumplings soaked in sugar syrup.",
    "image": "/images/gulab-jamun-indian-dessert-sweet.jpg",
    "category": {
      "id": 6,
      "name": "Desserts",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/desserts.png",
      "isRecommendedForMealSuggestion": false
    },
    "dishType": "DESSERT",
    "forChefit": true,
    "forParty": true,
    "nameHi": "गुलाब जामुन",
    "nameBn": "গোলাপ জামুন",
    "id": 7,
    "name": "Gulab Jamun",
    "ingredients": [
      {
        "name": "Milk Powder",
        "quantity": "1 cup"
      },
      {
        "name": "All Purpose Flour",
        "quantity": "2 tbsp"
      },
      {
        "name": "Sugar",
        "quantity": "2 cups"
      },
      {
        "name": "Cardamom",
        "quantity": "4 pods"
      }
    ]
  },
  {
    "categoryId": 3,
    "mealType": "MAIN COURSE",
    "type": "VEG",
    "description": "Stir-fried noodles with vegetables in Chinese style.",
    "image": "/images/hakka-noodles-chinese-stir-fried.png",
    "category": {
      "id": 3,
      "name": "Chinese",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/chinese.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "MAIN_COURSE",
    "forChefit": true,
    "forParty": true,
    "nameHi": "हक्का नूडल्स",
    "nameBn": "",
    "id": 8,
    "name": "Hakka Noodles",
    "ingredients": [
      {
        "name": "Noodles",
        "quantity": "200g"
      },
      {
        "name": "Cabbage",
        "quantity": "1 cup"
      },
      {
        "name": "Carrots",
        "quantity": "1 medium"
      },
      {
        "name": "Soy Sauce",
        "quantity": "2 tbsp"
      }
    ]
  },
  {
    "categoryId": 1,
    "mealType": "STARTER",
    "type": "VEG",
    "description": "Grilled cottage cheese cubes marinated in spices and yogurt.",
    "image": "/images/paneer-tikka-grilled-cubes.jpg",
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "APPETIZER",
    "forChefit": true,
    "forParty": true,
    "nameHi": "पनीर टिक्का",
    "nameBn": "",
    "id": 9,
    "name": "Paneer Tikka",
    "ingredients": [
      {
        "name": "Paneer",
        "quantity": "300g"
      },
      {
        "name": "Yogurt",
        "quantity": "1/2 cup"
      },
      {
        "name": "Bell Peppers",
        "quantity": "2 medium"
      },
      {
        "name": "Onion",
        "quantity": "1 large"
      }
    ]
  },
  {
    "categoryId": 5,
    "mealType": "MAIN COURSE",
    "type": "VEG",
    "description": "Spicy Italian pasta with tomatoes, garlic, and red chili.",
    "image": "/images/pasta-arrabbiata-italian-spicy.png",
    "category": {
      "id": 5,
      "name": "Italian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/italian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "MAIN_COURSE",
    "forChefit": true,
    "forParty": false,
    "nameHi": "",
    "nameBn": "",
    "id": 10,
    "name": "Pasta Arrabbiata",
    "ingredients": [
      {
        "name": "Penne Pasta",
        "quantity": "200g"
      },
      {
        "name": "Tomatoes",
        "quantity": "4 medium"
      },
      {
        "name": "Garlic",
        "quantity": "4 cloves"
      },
      {
        "name": "Red Chili Flakes",
        "quantity": "1 tsp"
      }
    ]
  },
  {
    "categoryId": 2,
    "mealType": "MAIN COURSE",
    "type": "VEG",
    "description": "Steamed rice cakes served with lentil curry.",
    "image": "/images/idli-sambar-south-indian.png",
    "category": {
      "id": 2,
      "name": "South Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/south_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "MAIN_COURSE",
    "forChefit": true,
    "forParty": false,
    "nameHi": "इडली सांबर",
    "nameBn": "ইডলি সাম্বার",
    "id": 11,
    "name": "Idli Sambar",
    "ingredients": [
      {
        "name": "Rice",
        "quantity": "2 cups"
      },
      {
        "name": "Urad Dal",
        "quantity": "1/2 cup"
      },
      {
        "name": "Toor Dal",
        "quantity": "1/2 cup"
      },
      {
        "name": "Tamarind",
        "quantity": "1 tbsp"
      }
    ]
  },
  {
    "categoryId": 1,
    "mealType": "MAIN COURSE",
    "type": "NON-VEG",
    "description": "Creamy tomato-based curry with tender chicken pieces.",
    "image": "/images/butter-chicken-curry-creamy.jpg",
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "MAIN_COURSE",
    "forChefit": true,
    "forParty": true,
    "nameHi": "बटर चिकन",
    "nameBn": "",
    "id": 12,
    "name": "Butter Chicken",
    "ingredients": [
      {
        "name": "Chicken",
        "quantity": "600g"
      },
      {
        "name": "Tomato Puree",
        "quantity": "1 cup"
      },
      {
        "name": "Heavy Cream",
        "quantity": "1/2 cup"
      },
      {
        "name": "Butter",
        "quantity": "3 tbsp"
      }
    ]
  },
  {
    "categoryId": 3,
    "mealType": "MAIN COURSE",
    "type": "NON-VEG",
    "description": "Wok-fried rice with chicken and vegetables in Chinese style.",
    "image": "/images/chicken-fried-rice-chinese.png",
    "category": {
      "id": 3,
      "name": "Chinese",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/chinese.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "MAIN_COURSE",
    "forChefit": true,
    "forParty": true,
    "nameHi": "चिकन फ्राइड राइस",
    "nameBn": "",
    "id": 13,
    "name": "Chicken Fried Rice",
    "ingredients": [
      {
        "name": "Basmati Rice",
        "quantity": "2 cups"
      },
      {
        "name": "Chicken",
        "quantity": "300g"
      },
      {
        "name": "Eggs",
        "quantity": "2"
      },
      {
        "name": "Spring Onions",
        "quantity": "3"
      }
    ]
  },
  {
    "categoryId": 4,
    "mealType": "MAIN COURSE",
    "type": "NON-VEG",
    "description": "Fresh mixed greens with grilled chicken and vinaigrette.",
    "image": "/images/grilled-chicken-salad-continental.png",
    "category": {
      "id": 4,
      "name": "Continental",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/continental.png",
      "isRecommendedForMealSuggestion": false
    },
    "dishType": "MAIN_COURSE",
    "forChefit": false,
    "forParty": false,
    "nameHi": "",
    "nameBn": "",
    "id": 14,
    "name": "Grilled Chicken Salad",
    "ingredients": [
      {
        "name": "Chicken Breast",
        "quantity": "300g"
      },
      {
        "name": "Mixed Greens",
        "quantity": "2 cups"
      },
      {
        "name": "Cherry Tomatoes",
        "quantity": "1 cup"
      },
      {
        "name": "Olive Oil",
        "quantity": "2 tbsp"
      }
    ]
  },
  {
    "categoryId": 5,
    "mealType": "DESSERT",
    "type": "VEG",
    "description": "Classic Italian dessert with coffee-soaked ladyfingers and mascarpone.",
    "image": "/images/tiramisu-italian-dessert.png",
    "category": {
      "id": 5,
      "name": "Italian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/italian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "DESSERT",
    "forChefit": false,
    "forParty": true,
    "nameHi": "",
    "nameBn": "",
    "id": 15,
    "name": "Tiramisu",
    "ingredients": [
      {
        "name": "Ladyfingers",
        "quantity": "200g"
      },
      {
        "name": "Mascarpone",
        "quantity": "250g"
      },
      {
        "name": "Coffee",
        "quantity": "1 cup"
      },
      {
        "name": "Cocoa Powder",
        "quantity": "2 tbsp"
      }
    ]
  },
  {
    "categoryId": 1,
    "mealType": "STARTER",
    "type": "NON-VEG",
    "description": "Grilled fish marinated in Indian spices and yogurt.",
    "image": "/images/fish-tikka-grilled-indian.jpg",
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "APPETIZER",
    "forChefit": true,
    "forParty": true,
    "nameHi": "फिश टिक्का",
    "nameBn": "",
    "id": 16,
    "name": "Fish Tikka",
    "ingredients": [
      {
        "name": "Fish Fillets",
        "quantity": "400g"
      },
      {
        "name": "Yogurt",
        "quantity": "1/2 cup"
      },
      {
        "name": "Ginger Garlic Paste",
        "quantity": "1 tbsp"
      },
      {
        "name": "Red Chili Powder",
        "quantity": "1 tsp"
      }
    ]
  },
  {
    "categoryId": 1,
    "mealType": "STARTER",
    "type": "VEG",
    "description": "Crispy potato patties served with chutneys.",
    "image": "/images/aloo-tikki-potato-patties.jpg",
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "APPETIZER",
    "forChefit": true,
    "forParty": true,
    "nameHi": "आलू टिक्की",
    "nameBn": "",
    "id": 17,
    "name": "Aloo Tikki",
    "ingredients": [
      {
        "name": "Potatoes",
        "quantity": "4 large"
      },
      {
        "name": "Green Peas",
        "quantity": "1/2 cup"
      },
      {
        "name": "Ginger",
        "quantity": "1 inch"
      },
      {
        "name": "Green Chilies",
        "quantity": "2"
      }
    ]
  },
  {
    "categoryId": 1,
    "mealType": "MAIN COURSE",
    "type": "VEG",
    "description": "Creamy spinach curry with cottage cheese cubes.",
    "image": "/images/palak-paneer-spinach-curry.jpg",
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "MAIN_COURSE",
    "forChefit": true,
    "forParty": true,
    "nameHi": "पालक पनीर",
    "nameBn": "",
    "id": 18,
    "name": "Palak Paneer",
    "ingredients": [
      {
        "name": "Spinach",
        "quantity": "500g"
      },
      {
        "name": "Paneer",
        "quantity": "200g"
      },
      {
        "name": "Onion",
        "quantity": "1 medium"
      },
      {
        "name": "Cream",
        "quantity": "2 tbsp"
      }
    ]
  },
  {
    "categoryId": 1,
    "mealType": "MAIN COURSE",
    "type": "NON-VEG",
    "description": "Spicy and aromatic mutton curry with traditional Indian spices.",
    "image": "/images/mutton-curry-indian-spicy.jpg",
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "MAIN_COURSE",
    "forChefit": true,
    "forParty": true,
    "nameHi": "मटन करी",
    "nameBn": "",
    "id": 19,
    "name": "Mutton Curry",
    "ingredients": [
      {
        "name": "Mutton",
        "quantity": "500g"
      },
      {
        "name": "Onions",
        "quantity": "2 large"
      },
      {
        "name": "Tomatoes",
        "quantity": "3 medium"
      },
      {
        "name": "Garam Masala",
        "quantity": "1 tsp"
      }
    ]
  },
  {
    "categoryId": 1,
    "mealType": "MAIN COURSE",
    "type": "VEG",
    "description": "Spicy chickpea curry served with deep-fried bread.",
    "image": "/images/chole-bhature-chickpea-curry.jpg",
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "MAIN_COURSE",
    "forChefit": true,
    "forParty": true,
    "nameHi": "छोले भटूरे",
    "nameBn": "",
    "id": 20,
    "name": "Chole Bhature",
    "ingredients": [
      {
        "name": "Chickpeas",
        "quantity": "2 cups"
      },
      {
        "name": "All Purpose Flour",
        "quantity": "2 cups"
      },
      {
        "name": "Yogurt",
        "quantity": "1/4 cup"
      },
      {
        "name": "Baking Powder",
        "quantity": "1/2 tsp"
      }
    ]
  },
  {
    "categoryId": 1,
    "mealType": "SIDES",
    "type": "VEG",
    "description": "Fragrant basmati rice cooked with cumin seeds.",
    "image": "/images/jeera-rice-cumin-basmati.jpg",
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "SIDE",
    "forChefit": true,
    "forParty": true,
    "nameHi": "जीरा चावल",
    "nameBn": "",
    "id": 21,
    "name": "Jeera Rice",
    "ingredients": [
      {
        "name": "Basmati Rice",
        "quantity": "2 cups"
      },
      {
        "name": "Cumin Seeds",
        "quantity": "1 tsp"
      },
      {
        "name": "Bay Leaves",
        "quantity": "2"
      },
      {
        "name": "Ghee",
        "quantity": "2 tbsp"
      }
    ]
  },
  {
    "categoryId": 1,
    "mealType": "SIDES",
    "type": "VEG",
    "description": "Soft Indian bread topped with garlic and herbs.",
    "image": "/images/garlic-naan-bread-indian.jpg",
    "category": {
      "id": 1,
      "name": "North Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "SIDE",
    "forChefit": true,
    "forParty": true,
    "nameHi": "गार्लिक नान",
    "nameBn": "",
    "id": 22,
    "name": "Garlic Naan",
    "ingredients": [
      {
        "name": "All Purpose Flour",
        "quantity": "2 cups"
      },
      {
        "name": "Yogurt",
        "quantity": "1/4 cup"
      },
      {
        "name": "Garlic",
        "quantity": "6 cloves"
      },
      {
        "name": "Coriander",
        "quantity": "2 tbsp"
      }
    ]
  },
  {
    "categoryId": 6,
    "mealType": "DESSERT",
    "type": "VEG",
    "description": "Traditional Indian frozen dessert with cardamom and pistachios.",
    "image": "/images/kulfi-indian-ice-cream.jpg",
    "category": {
      "id": 6,
      "name": "Desserts",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/desserts.png",
      "isRecommendedForMealSuggestion": false
    },
    "dishType": "DESSERT",
    "forChefit": true,
    "forParty": true,
    "nameHi": "कुल्फी",
    "nameBn": "",
    "id": 23,
    "name": "Kulfi",
    "ingredients": [
      {
        "name": "Full Fat Milk",
        "quantity": "1 liter"
      },
      {
        "name": "Sugar",
        "quantity": "1/2 cup"
      },
      {
        "name": "Cardamom Powder",
        "quantity": "1/2 tsp"
      },
      {
        "name": "Pistachios",
        "quantity": "1/4 cup"
      }
    ]
  },
  {
    "categoryId": 2,
    "mealType": "STARTER",
    "type": "VEG",
    "description": "Crispy lentil donuts served with spicy lentil curry.",
    "image": "/images/vada-sambar-south-indian.png",
    "category": {
      "id": 2,
      "name": "South Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/south_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "APPETIZER",
    "forChefit": true,
    "forParty": true,
    "nameHi": "वड़ा सांबर",
    "nameBn": "ভাদা সাম্বার",
    "id": 24,
    "name": "Vada Sambar",
    "ingredients": [
      {
        "name": "Urad Dal",
        "quantity": "1 cup"
      },
      {
        "name": "Toor Dal",
        "quantity": "1/2 cup"
      },
      {
        "name": "Curry Leaves",
        "quantity": "10"
      },
      {
        "name": "Mustard Seeds",
        "quantity": "1 tsp"
      }
    ]
  },
  {
    "categoryId": 2,
    "mealType": "SIDES",
    "type": "VEG",
    "description": "Tangy South Indian soup with tamarind and spices.",
    "image": "/images/rasam-south-indian-soup.png",
    "category": {
      "id": 2,
      "name": "South Indian",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/south_indian.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "SIDE",
    "forChefit": true,
    "forParty": false,
    "nameHi": "रसम",
    "nameBn": "রসম",
    "id": 25,
    "name": "Rasam",
    "ingredients": [
      {
        "name": "Tamarind",
        "quantity": "2 tbsp"
      },
      {
        "name": "Tomatoes",
        "quantity": "2 medium"
      },
      {
        "name": "Rasam Powder",
        "quantity": "1 tbsp"
      },
      {
        "name": "Curry Leaves",
        "quantity": "8"
      }
    ]
  },
  {
    "categoryId": 3,
    "mealType": "STARTER",
    "type": "VEG",
    "description": "Deep-fried vegetable balls in spicy Chinese sauce.",
    "image": "/images/manchurian-chinese-balls.png",
    "category": {
      "id": 3,
      "name": "Chinese",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/chinese.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "APPETIZER",
    "forChefit": true,
    "forParty": true,
    "nameHi": "मंचूरियन",
    "nameBn": "",
    "id": 26,
    "name": "Manchurian",
    "ingredients": [
      {
        "name": "Cabbage",
        "quantity": "2 cups"
      },
      {
        "name": "Carrots",
        "quantity": "1 cup"
      },
      {
        "name": "Cornflour",
        "quantity": "1/2 cup"
      },
      {
        "name": "Soy Sauce",
        "quantity": "2 tbsp"
      }
    ]
  },
  {
    "categoryId": 3,
    "mealType": "MAIN COURSE",
    "type": "NON-VEG",
    "description": "Crispy chicken in tangy sweet and sour sauce.",
    "image": "/images/sweet-sour-chicken-chinese.png",
    "category": {
      "id": 3,
      "name": "Chinese",
      "image": "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/chinese.png",
      "isRecommendedForMealSuggestion": true
    },
    "dishType": "MAIN_COURSE",
    "forChefit": true,
    "forParty": true,
    "nameHi": "स्वीट एंड साउर चिकन",
    "nameBn": "",
    "id": 27,
    "name": "Sweet and Sour Chicken",
    "ingredients": [
      {
        "name": "Chicken",
        "quantity": "400g"
      },
      {
        "name": "Bell Peppers",
        "quantity": "2"
      },
      {
        "name": "Pineapple",
        "quantity": "1 cup"
      },
      {
        "name": "Tomato Sauce",
        "quantity": "3 tbsp"
      }
    ]
  }
]

export const categories = [
  {
    id: 1,
    name: "North Indian",
    image: "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/north_indian.png",
    isRecommendedForMealSuggestion: true,
  },
  {
    id: 2,
    name: "South Indian",
    image: "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/south_indian.png",
    isRecommendedForMealSuggestion: true,
  },
  {
    id: 3,
    name: "Chinese",
    image: "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/chinese.png",
    isRecommendedForMealSuggestion: true,
  },
  {
    id: 4,
    name: "Continental",
    image: "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/continental.png",
    isRecommendedForMealSuggestion: false,
  },
  {
    id: 5,
    name: "Italian",
    image: "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/italian.png",
    isRecommendedForMealSuggestion: true,
  },
  {
    id: 6,
    name: "Desserts",
    image: "https://storage.googleapis.com/chefkartimages/customer_app_assets/star_chef/desserts.png",
    isRecommendedForMealSuggestion: false,
  },
]


*/
